import { render, staticRenderFns } from "./Section8.vue?vue&type=template&id=390cc5d2&scoped=true&"
import script from "./Section8.vue?vue&type=script&lang=js&"
export * from "./Section8.vue?vue&type=script&lang=js&"
import style0 from "./Section8.vue?vue&type=style&index=0&id=390cc5d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390cc5d2",
  null
  
)

export default component.exports